export default class Column {
  constructor(rawValue, formattedValue, Component, width, columnMetadata) {
    this.rawValue = rawValue;
    this.formattedValue = formattedValue;
    this.Component = Component;
    this.width = width;
    this.columnMetadata = columnMetadata;
  }
}
